import request from "../request"
import qs from "qs";


export function getAllStationData() {
    return request.get({
        url: "/station/all"
    })
}
export function getAirspaceTableData(params) {
    return request.get({
        url: "/airspace/page",
        params: params
    })
}
export function getAirApproachControlTableData(params) {
    return request.get({
        url: "/route/page",
        params: params
    })
}
export function getAirspaceDataById(params) {
    return request.get({
        url: "/airspace/one",
        params: params
    })
}
export function getAirApproachControlDataById(params) {
    return request.get({
        url: "/route/one",
        params: params
    })
}
export function editAirspaceData(data) {
    return request.post({
        url: "/airspace/saveorupdate",
        data: qs.stringify(data),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })
}
export function editAirApproachControlData(data) {
    return request.post({
        url: "/route/saveorupdate",
        data: qs.stringify(data),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })
}
export function deleteAirspaceData(params) {
    return request.delete({
        url: "/airspace/del",
        params: params
    })
}
export function deleteAirApproachControlData(params) {
    return request.delete({
        url: "/route/del",
        params: params
    })
}